// import "./App.css";
// import "bootstrap-4-react";
// import "react-bootstrap";
// import "react-icons/fa";

// import { BrowserRouter, Routes, Route, Outlet, useParams } from "react-router-dom";
// import { LoadScript } from "@react-google-maps/api";
// import { Provider } from "react-redux";
// import store from "./redux/store";
// import { ToastProvider } from "./context/ToastContext";
// import { SettingsProvider } from "./context/SettingsContext";
// import { TenantProvider } from "./context/TenantContext";

// import { AuthProvider } from "./components/AuthContext";

// import ProjectsLayout          from "./components/ProjectsLayout";
// import GoogleMapWithMarkers    from "./components/GoogleMapWithMarkers";
// import PaymentSuccessPage      from "./components/PaymentSuccessPage";
// import ApartmentViewer         from "./components/ApartmentViewer";
// import FloorPlanPage           from "./components/FloorPlanPage";
// import PanoramaViewer          from "./components/PanoramaViewer";
// import UnitPage                from "./components/UnitPage";
// import RoomPanoramaPage        from "./components/RoomPanoramaPage";
// import GalleryPanoramaPage     from "./components/GalleryPanoramaPage";
// import PaymentPage             from "./components/PaymentPage";
// import UserDashboard           from "./components/UserDashboard";
// import ChatBubble              from "./components/ChatBubble";
// import PublicPaymentPage from "./components/PublicPaymentPage";

// const MAPS_LIBRARIES = ["places"];

// /**
//  * Everything under here KNOWS which tenant it's rendering for.
//  * SettingsProvider and AuthProvider moved from top-level App into this
//  * layout, because both need the tenant slug before they can do anything
//  * useful:
//  *   - SettingsProvider needs it to call /api/{tenant}/settings instead
//  *     of the old global /api/settings.
//  *   - AuthProvider needs it to scope the login token (see note below —
//  *     you'll need to update AuthContext.js to accept/use this prop).
//  *
//  * NOTE: I don't have the current source for SettingsContext.js or
//  * AuthContext.js, so I haven't edited them — but both need a `tenant`
//  * prop now and must use it in their fetch calls / token storage keys
//  * (localStorage key like `token_${tenant}`, matching apiClient.js).
//  */
// function TenantLayout() {
//   const { tenant } = useParams();

//   return (
//     <TenantProvider tenant={tenant}>
//       <SettingsProvider tenant={tenant}>
//         <AuthProvider tenant={tenant}>
//           <ToastProvider>
//             <Outlet />
//             <ChatBubble />
//           </ToastProvider>
//         </AuthProvider>
//       </SettingsProvider>
//     </TenantProvider>
//   );
// }

// function App() {
//   return (
//     <LoadScript
//       googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
//       libraries={MAPS_LIBRARIES}
//     >
//       <BrowserRouter basename="/plot-booking-system">
//         <Provider store={store}>
//           <Routes>
//             {/* Everything now lives under /:tenant, e.g.
//                 /book-an-apartment/marquis-developers/location/12 */}
//             <Route path="/:tenant" element={<TenantLayout />}>
//               <Route index                                element={<ProjectsLayout />} />
//               <Route path="location/:projectId"            element={<GoogleMapWithMarkers />} />
//               <Route path="payment-success"                element={<PaymentSuccessPage />} />
//               <Route path="apartment-view/:masterPlanId"    element={<ApartmentViewer />} />
//               <Route path="floor/:floorId"                  element={<FloorPlanPage />} />
//               <Route path="unit/:plotId"                    element={<UnitPage />} />
//               <Route path="unit/:plotId/room/:roomId"       element={<RoomPanoramaPage />} />
//               <Route path="floor/:floorId/room/:roomId"     element={<PanoramaViewer />} />
//               <Route path="unit/:plotId/gallery/:index"     element={<GalleryPanoramaPage />} />
//               <Route path="payment/:bookingId"              element={<PaymentPage />} />
//               <Route path="pay/:bookingId" element={<PublicPaymentPage />} />
//               <Route path="dashboard"                       element={<UserDashboard />} />
//             </Route>

//             {/* No tenant slug in the URL — someone hit the bare domain
//                 instead of their emailed site link. ProjectsLayout itself
//                 detects the missing :tenant param and shows a "register /
//                 contact us" screen instead of any tenant's data. Deliberately
//                 NOT wrapped in TenantLayout — there's no tenant to resolve. */}
//             <Route path="/" element={<ProjectsLayout />} />
//           </Routes>
//         </Provider>
//       </BrowserRouter>
//     </LoadScript>
//   );
// }

// export default App;

// import "./App.css";
// import "bootstrap-4-react";
// import "react-bootstrap";
// import "react-icons/fa";

// import { BrowserRouter, Routes, Route, Outlet, useParams, useLocation } from "react-router-dom";
// import { LoadScript } from "@react-google-maps/api";
// import { Provider } from "react-redux";
// import store from "./redux/store";
// import { ToastProvider } from "./context/ToastContext";
// import { SettingsProvider } from "./context/SettingsContext";
// import { TenantProvider } from "./context/TenantContext";

// import { AuthProvider } from "./context/AuthContext";

// import ProjectsLayout          from "./components/ProjectsLayout";
// import GoogleMapWithMarkers    from "./components/GoogleMapWithMarkers";
// import PaymentSuccessPage      from "./components/PaymentSuccessPage";
// import ApartmentViewer         from "./components/ApartmentViewer";
// import FloorPlanPage           from "./components/FloorPlanPage";
// import PanoramaViewer          from "./components/PanoramaViewer";
// import UnitPage                from "./components/UnitPage";
// import RoomPanoramaPage        from "./components/RoomPanoramaPage";
// import GalleryPanoramaPage     from "./components/GalleryPanoramaPage";
// import PaymentPage             from "./components/PaymentPage";
// import UserDashboard           from "./components/UserDashboard";
// import ChatBubble              from "./components/ChatBubble";
// import PublicPaymentPage from "./components/PublicPaymentPage";

// const MAPS_LIBRARIES = ["places"];

// // Routes where the chat widget should NOT appear — a client arriving from
// // a payment-link email is mid-transaction; a floating chat bubble is
// // distracting clutter on that page, not a helpful affordance.
// const CHAT_HIDDEN_PATH_PATTERNS = [/^\/pay\/[^/]+$/];

// /**
//  * Everything under here KNOWS which tenant it's rendering for.
//  * SettingsProvider and AuthProvider moved from top-level App into this
//  * layout, because both need the tenant slug before they can do anything
//  * useful:
//  *   - SettingsProvider needs it to call /api/{tenant}/settings instead
//  *     of the old global /api/settings.
//  *   - AuthProvider needs it to scope the login token (see note below —
//  *     you'll need to update AuthContext.js to accept/use this prop).
//  *
//  * NOTE: I don't have the current source for SettingsContext.js or
//  * AuthContext.js, so I haven't edited them — but both need a `tenant`
//  * prop now and must use it in their fetch calls / token storage keys
//  * (localStorage key like `token_${tenant}`, matching apiClient.js).
//  */
// function TenantLayout() {
//   const { tenant } = useParams();
//   const location = useLocation();

//   // location.pathname includes the leading /:tenant segment (e.g.
//   // "/marquis-developers/pay/123"), so strip it before matching against
//   // the patterns above, which are written relative to the tenant root.
//   const pathWithoutTenant = tenant
//     ? location.pathname.replace(new RegExp(`^/${tenant}`), "") || "/"
//     : location.pathname;

//   const hideChatBubble = CHAT_HIDDEN_PATH_PATTERNS.some((pattern) => pattern.test(pathWithoutTenant));

//   return (
//     <TenantProvider tenant={tenant}>
//       <SettingsProvider tenant={tenant}>
//         <AuthProvider tenant={tenant}>
//           <ToastProvider>
//             <Outlet />
//             {!hideChatBubble && <ChatBubble />}
//           </ToastProvider>
//         </AuthProvider>
//       </SettingsProvider>
//     </TenantProvider>
//   );
// }

// function App() {
//   return (
//     <LoadScript
//       googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
//       libraries={MAPS_LIBRARIES}
//     >
//       <BrowserRouter basename="/plot-booking-system">
//         <Provider store={store}>
//           <Routes>
//             {/* Everything now lives under /:tenant, e.g.
//                 /book-an-apartment/marquis-developers/location/12 */}
//             <Route path="/:tenant" element={<TenantLayout />}>
//               <Route index                                element={<ProjectsLayout />} />
//               <Route path="location/:projectId"            element={<GoogleMapWithMarkers />} />
//               <Route path="payment-success"                element={<PaymentSuccessPage />} />
//               <Route path="apartment-view/:masterPlanId"    element={<ApartmentViewer />} />
//               <Route path="floor/:floorId"                  element={<FloorPlanPage />} />
//               <Route path="unit/:plotId"                    element={<UnitPage />} />
//               <Route path="unit/:plotId/room/:roomId"       element={<RoomPanoramaPage />} />
//               <Route path="floor/:floorId/room/:roomId"     element={<PanoramaViewer />} />
//               <Route path="unit/:plotId/gallery/:index"     element={<GalleryPanoramaPage />} />
//               <Route path="payment/:bookingId"              element={<PaymentPage />} />
//               <Route path="pay/:bookingId" element={<PublicPaymentPage />} />
//               <Route path="dashboard"                       element={<UserDashboard />} />
//             </Route>

//             {/* No tenant slug in the URL — someone hit the bare domain
//                 instead of their emailed site link. ProjectsLayout itself
//                 detects the missing :tenant param and shows a "register /
//                 contact us" screen instead of any tenant's data. Deliberately
//                 NOT wrapped in TenantLayout — there's no tenant to resolve. */}
//             <Route path="/" element={<ProjectsLayout />} />
//           </Routes>
//         </Provider>
//       </BrowserRouter>
//     </LoadScript>
//   );
// }

// export default App;

// import "./App.css";
// import "bootstrap-4-react";
// import "react-bootstrap";
// import "react-icons/fa";

// import { BrowserRouter, Routes, Route, Outlet, useParams, useLocation } from "react-router-dom";
// import { LoadScript } from "@react-google-maps/api";
// import { Provider } from "react-redux";
// import store from "./redux/store";
// import { ToastProvider } from "./context/ToastContext";
// import { SettingsProvider, useSettings } from "./context/SettingsContext";
// import { TenantProvider } from "./context/TenantContext";

// import { AuthProvider } from "./context/AuthContext";

// import ProjectsLayout          from "./components/ProjectsLayout";
// import GoogleMapWithMarkers    from "./components/GoogleMapWithMarkers";
// import PaymentSuccessPage      from "./components/PaymentSuccessPage";
// import ApartmentViewer         from "./components/ApartmentViewer";
// import FloorPlanPage           from "./components/FloorPlanPage";
// import PanoramaViewer          from "./components/PanoramaViewer";
// import UnitPage                from "./components/UnitPage";
// import RoomPanoramaPage        from "./components/RoomPanoramaPage";
// import GalleryPanoramaPage     from "./components/GalleryPanoramaPage";
// import PaymentPage             from "./components/PaymentPage";
// import UserDashboard           from "./components/UserDashboard";
// import ChatBubble              from "./components/ChatBubble";
// import PublicPaymentPage from "./components/PublicPaymentPage";

// const MAPS_LIBRARIES = ["places"];

// // Routes where the chat widget should NOT appear — a client arriving from
// // a payment-link email is mid-transaction; a floating chat bubble is
// // distracting clutter on that page, not a helpful affordance.
// const CHAT_HIDDEN_PATH_PATTERNS = [/^\/pay\/[^/]+$/];

// /**
//  * TenantGate — sits inside SettingsProvider (so useSettings() is available)
//  * and blocks every tenant-scoped route the instant a platform admin
//  * suspends the tenant. This is the single place suspension is checked —
//  * individual pages (ProjectsLayout, ApartmentViewer, UnitPage, dashboard,
//  * payment pages, etc.) don't each need their own copy of this check.
//  *
//  * ASSUMPTION: /api/{tenant}/settings returns `is_suspended: true` (or
//  * `status: "suspended"`) once a platform_admin suspends the tenant. If your
//  * actual field name differs, this is the only place to update it.
//  */
// function TenantGate({ children }) {
//   const { settings, isLoaded } = useSettings();

//   // Don't render anything conclusive until settings have actually loaded —
//   // individual pages already show their own loading states underneath.
//   if (!isLoaded) return children;

//   const isSuspended =
//     settings?.is_suspended === true || settings?.status === "suspended";

//     console.log(settings);

//   if (isSuspended) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           gap: 14,
//           background: settings?.page_bg_color || "#f5f0e8",
//           fontFamily: settings?.body_font || "sans-serif",
//           padding: "40px 20px",
//           textAlign: "center",
//         }}
//       >
//         <div
//           style={{
//             width: 56,
//             height: 56,
//             borderRadius: "50%",
//             border: `1px solid ${settings?.card_border_color || "#e2dbd0"}`,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: 20,
//             color: settings?.text_color_muted || "#7a7065",
//           }}
//         >
//           🔒
//         </div>
//         <div
//           style={{
//             fontSize: 24,
//             fontWeight: 500,
//             color: settings?.text_color_dark || "#1a1813",
//           }}
//         >
//           Site unavailable
//         </div>
//         <div
//           style={{
//             fontSize: 14,
//             color: settings?.text_color_muted || "#7a7065",
//             maxWidth: 380,
//             lineHeight: 1.7,
//           }}
//         >
//           This site has been temporarily suspended. If you believe this is a
//           mistake, please contact your account administrator.
//         </div>
//       </div>
//     );
//   }

//   return children;
// }

// /**
//  * Everything under here KNOWS which tenant it's rendering for.
//  * SettingsProvider and AuthProvider moved from top-level App into this
//  * layout, because both need the tenant slug before they can do anything
//  * useful — see AuthContext.jsx for how AuthProvider uses its `tenant` prop
//  * to scope both storage keys and API calls per tenant.
//  */
// function TenantLayout() {
//   const { tenant } = useParams();
//   const location = useLocation();

//   // location.pathname includes the leading /:tenant segment (e.g.
//   // "/marquis-developers/pay/123"), so strip it before matching against
//   // the patterns above, which are written relative to the tenant root.
//   const pathWithoutTenant = tenant
//     ? location.pathname.replace(new RegExp(`^/${tenant}`), "") || "/"
//     : location.pathname;

//   const hideChatBubble = CHAT_HIDDEN_PATH_PATTERNS.some((pattern) => pattern.test(pathWithoutTenant));

//   return (
//     <TenantProvider tenant={tenant}>
//       <SettingsProvider tenant={tenant}>
//         <AuthProvider tenant={tenant}>
//           <ToastProvider>
//             <TenantGate>
//               <Outlet />
//               {!hideChatBubble && <ChatBubble />}
//             </TenantGate>
//           </ToastProvider>
//         </AuthProvider>
//       </SettingsProvider>
//     </TenantProvider>
//   );
// }

// function App() {
//   return (
//     <LoadScript
//       googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
//       libraries={MAPS_LIBRARIES}
//     >
//       <BrowserRouter basename="/plot-booking-system">
//         <Provider store={store}>
//           <Routes>
//             {/* Everything now lives under /:tenant, e.g.
//                 /book-an-apartment/marquis-developers/location/12 */}
//             <Route path="/:tenant" element={<TenantLayout />}>
//               <Route index                                element={<ProjectsLayout />} />
//               <Route path="location/:projectId"            element={<GoogleMapWithMarkers />} />
//               <Route path="payment-success"                element={<PaymentSuccessPage />} />
//               <Route path="apartment-view/:masterPlanId"    element={<ApartmentViewer />} />
//               <Route path="floor/:floorId"                  element={<FloorPlanPage />} />
//               <Route path="unit/:plotId"                    element={<UnitPage />} />
//               <Route path="unit/:plotId/room/:roomId"       element={<RoomPanoramaPage />} />
//               <Route path="floor/:floorId/room/:roomId"     element={<PanoramaViewer />} />
//               <Route path="unit/:plotId/gallery/:index"     element={<GalleryPanoramaPage />} />
//               <Route path="payment/:bookingId"              element={<PaymentPage />} />
//               <Route path="pay/:bookingId" element={<PublicPaymentPage />} />
//               <Route path="dashboard"                       element={<UserDashboard />} />
//             </Route>

//             {/* No tenant slug in the URL at all — someone hit the bare domain
//                 instead of their emailed site link. ProjectsLayout itself
//                 detects the missing :tenant param and shows a "register /
//                 contact us" screen instead of any tenant's data. Deliberately
//                 NOT wrapped in TenantLayout — there's no tenant to resolve. */}
//             <Route path="/" element={<ProjectsLayout />} />
//           </Routes>
//         </Provider>
//       </BrowserRouter>
//     </LoadScript>
//   );
// }

// export default App;

import "./App.css";
import "bootstrap-4-react";
import "react-bootstrap";
import "react-icons/fa";

import { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  useParams,
  useLocation,
} from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastProvider } from "./context/ToastContext";
import { SettingsProvider, useSettings } from "./context/SettingsContext";
import { TenantProvider } from "./context/TenantContext";
import { apiJson } from "./api/apiClient";
import tenantService from "./services/tenantService";

import { AuthProvider } from "./context/AuthContext";

import ProjectsLayout from "./components/ProjectsLayout";
import GoogleMapWithMarkers from "./components/GoogleMapWithMarkers";
import PaymentSuccessPage from "./components/PaymentSuccessPage";
import ApartmentViewer from "./components/ApartmentViewer";
import FloorPlanPage from "./components/FloorPlanPage";
import PanoramaViewer from "./components/PanoramaViewer";
import UnitPage from "./components/UnitPage";
import ProjectLandingPage from "./components/ProjectLandingPage";
import RoomPanoramaPage from "./components/RoomPanoramaPage";
import GalleryPanoramaPage from "./components/GalleryPanoramaPage";
import PaymentPage from "./components/PaymentPage";
import UserDashboard from "./components/UserDashboard";
import ChatBubble from "./components/ChatBubble";
import PublicPaymentPage from "./components/PublicPaymentPage";

const MAPS_LIBRARIES = ["places"];

// Routes where the chat widget should NOT appear — a client arriving from
// a payment-link email is mid-transaction; a floating chat bubble is
// distracting clutter on that page, not a helpful affordance.
const CHAT_HIDDEN_PATH_PATTERNS = [/^\/pay\/[^/]+$/];

/**
 * TenantGate — checks the tenant's status DIRECTLY against the tenant
 * table via tenantService.checkTenantStatus(), hitting a dedicated
 * /tenant-status endpoint — deliberately not /settings, which doesn't
 * carry this field and may itself error for a suspended tenant.
 *
 * Requires a backend route: GET /api/{tenant}/tenant-status
 * -> { status: "active" | "suspended" | ... }
 * This route must succeed regardless of the tenant's own status (it's
 * the thing deciding whether to show the suspended screen), so it
 * should look the tenant up by slug without any "must be active" guard.
 *
 * Fails OPEN on error/timeout (renders children rather than blocking) so
 * a flaky network call never locks a healthy tenant out of their own
 * site. If you'd rather fail CLOSED (block on any doubt), flip the catch
 * block's `suspended` value to `true`.
 */
function TenantGate({ children }) {
  const { tenant } = useParams();
  const [state, setState] = useState({ loading: true, suspended: false });

  useEffect(() => {
    if (!tenant) {
      setState({ loading: false, suspended: false });
      return;
    }
    let cancelled = false;

    tenantService
      .checkTenantStatus(tenant)
      .then(({ isSuspended }) => {
        if (cancelled) return;
        setState({ loading: false, suspended: isSuspended });
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("Tenant status check failed:", err);
        setState({ loading: false, suspended: false }); // fail open — see note below
      });

    return () => {
      cancelled = true;
    };
  }, [tenant]);

  if (state.loading) return children;

  if (state.suspended) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 14,
          background: "#f5f0e8",
          fontFamily: "sans-serif",
          padding: "40px 20px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            border: "1px solid #e2dbd0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 20,
            color: "#7a7065",
          }}
        >
          🔒
        </div>
        <div style={{ fontSize: 24, fontWeight: 500, color: "#1a1813" }}>
          Site unavailable
        </div>
        <div
          style={{
            fontSize: 14,
            color: "#7a7065",
            maxWidth: 380,
            lineHeight: 1.7,
          }}
        >
          This site has been temporarily suspended. If you believe this is a
          mistake, please contact your account administrator.
        </div>
      </div>
    );
  }

  return children;
}

/**
 * Everything under here KNOWS which tenant it's rendering for.
 * SettingsProvider and AuthProvider moved from top-level App into this
 * layout, because both need the tenant slug before they can do anything
 * useful — see AuthContext.jsx for how AuthProvider uses its `tenant` prop
 * to scope both storage keys and API calls per tenant.
 */
function TenantLayout() {
  const { tenant } = useParams();
  const location = useLocation();

  // location.pathname includes the leading /:tenant segment (e.g.
  // "/marquis-developers/pay/123"), so strip it before matching against
  // the patterns above, which are written relative to the tenant root.
  const pathWithoutTenant = tenant
    ? location.pathname.replace(new RegExp(`^/${tenant}`), "") || "/"
    : location.pathname;

  const hideChatBubble = CHAT_HIDDEN_PATH_PATTERNS.some((pattern) =>
    pattern.test(pathWithoutTenant),
  );

  return (
    <TenantProvider tenant={tenant}>
      <SettingsProvider tenant={tenant}>
        <AuthProvider tenant={tenant}>
          <ToastProvider>
            <TenantGate>
              <Outlet />
              {!hideChatBubble && <ChatBubble />}
            </TenantGate>
          </ToastProvider>
        </AuthProvider>
      </SettingsProvider>
    </TenantProvider>
  );
}

function App() {
  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={MAPS_LIBRARIES}
    >
      <BrowserRouter basename="/plot-booking-system">
        <Provider store={store}>
          <Routes>
            {/* Everything now lives under /:tenant, e.g.
                /book-an-apartment/marquis-developers/location/12 */}
            <Route path="/:tenant" element={<TenantLayout />}>
              <Route index element={<ProjectsLayout />} />
              <Route
                path="location/:projectId"
                element={<GoogleMapWithMarkers />}
              />
              <Route
                path="project/:projectId"
                element={<ProjectLandingPage />}
              />
              <Route path="payment-success" element={<PaymentSuccessPage />} />
              <Route
                path="apartment-view/:masterPlanId"
                element={<ApartmentViewer />}
              />
              <Route path="floor/:floorId" element={<FloorPlanPage />} />
              <Route path="unit/:plotId" element={<UnitPage />} />
              <Route
                path="unit/:plotId/room/:roomId"
                element={<RoomPanoramaPage />}
              />
              <Route
                path="floor/:floorId/room/:roomId"
                element={<PanoramaViewer />}
              />
              <Route
                path="unit/:plotId/gallery/:index"
                element={<GalleryPanoramaPage />}
              />
              <Route path="payment/:bookingId" element={<PaymentPage />} />
              <Route path="pay/:bookingId" element={<PublicPaymentPage />} />
              <Route path="dashboard" element={<UserDashboard />} />
            </Route>

            {/* No tenant slug in the URL at all — someone hit the bare domain
                instead of their emailed site link. ProjectsLayout itself
                detects the missing :tenant param and shows a "register /
                contact us" screen instead of any tenant's data. Deliberately
                NOT wrapped in TenantLayout — there's no tenant to resolve. */}
            <Route path="/" element={<ProjectsLayout />} />
          </Routes>
        </Provider>
      </BrowserRouter>
    </LoadScript>
  );
}

export default App;
